// Maps locale unsupported by some browsers to fallbacks array
export const LOCALE_FALLBACKS = {
  // 'no' macrolanguage isn't supported by modern browsers (Chrome, Firefox, Edge)
  'no-NO': [ 'no-NO', 'nb', 'nn', 'da' ],
};

export const fractionDigits = {
  MIN: 2,
  MAX: 2,
} as const;

export const enum ECurrency {
  EUR = 'EUR',
}
